export default () => ({
    open: false,

    toggle(isOpen) {
        this.open = isOpen;
        Grebify.noScroll(isOpen);
        Grebify.setCSSVariable('--menu-color', isOpen ? 'var(--menu-active-color)' : 'var(--menu-primary-color)');
        Grebify.setCSSVariable('--menu-button', isOpen ? '#F0EBE7' : 'var(--menu-button-text)');
        
        let header = document.getElementById('header');
        if (this.open) {
            header.classList.add('header-background');
        } else {
            header.classList.remove('header-background');
        }
    }
});